/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import {
    take, fork, call, put, select, takeEvery,
} from 'redux-saga/effects';

import mbpLogger from 'mbp-logger';

import cartServiceClient from '../../../../../../apis/cart-service-apis/cartServiceClient';

// Actions
import { clearErrors } from '../../../../Common/ducks/Error/Error-Actions';
import { showLoadingMessageActions } from '../../../../Common/ducks/ShowLoadingMessage';
import {
    calculateCart,
    calculateCartComplete,
    cartServiceCalculateCart,
    cartServiceCalculateCartCompleted,
    updateCalculateShippingApplied,
    calcualteShippingPaymentMethodIsChanged,
    calcualteShippingPaymentMethodIsChangedCompleted,
} from './CalculateCart-Actions';
import { callHandleCartFailure } from '../../Cart/Cart-Actions';

// Selectors
import {
    getOrderId,
} from '../../../../Common/Common-Selectors';

import {
    getGiftCards,
    getAppliedPromotions,
} from '../../Cart/Cart-Selectors';

// Operations
// import { arrErrorCodes /* getError */ } from '../../../../Common/ducks/Error/Error-Operations';
import { retrieveCart } from '../../Cart/ducks/RetrieveCart/RetrieveCart-Operations';
import { checkJWT } from '../../../../Checkout/ducks/Global/Global-Operations';
import { recalculateGiftCardTotal, recalculateGiftCardTotalCompleted } from '../GiftCard/GiftCard-Actions';
import { disablePaymentFields } from '../../../../Checkout/ducks/Common/Common-Selectors';
import { processFeatureErrors } from '../../../../Checkout/ducks/Common/ducks/Error/Error-Operations';
import { clearOrderItemErrors } from '../../../../Checkout/ducks/Common/ducks/Error/Error-Actions';

export function* workerCalculateCart(action) {
    const cartId = yield select(getOrderId);
    const logOrderId = yield select(getOrderId);

    try {
        if (cartId) {
            const jwtToken = yield call(checkJWT);

            mbpLogger.logDebug({
                appName: process.env.npm_package_name,
                module: 'mbp-checkout',
                function: 'workerCalculateCart',
                message: 'Call - Calculate Cart API',
                orderId: logOrderId,
            });

            const headers = {};

            const payload = {
                env: {},
                jwtToken,
                cartId,
                headers,
            };

            if (action?.calcode) {
                payload.payload = {
                    calcode: action.calcode,
                };
            }

            // Call Calculate Shipping API
            const calculatOrd = yield call(
                cartServiceClient.calculateCart, payload);
            mbpLogger.logDebug({
                appName: process.env.npm_package_name,
                module: 'mbp-checkout',
                function: 'workerCalculateCart',
                message: 'Response - Calculate Cart API',
                orderId: logOrderId,
            });

            const { successFlag, result } = calculatOrd.data;
            if (successFlag === true || successFlag === 'true' || result === 'SUCCESS') {
                yield put(clearErrors({
                    errType: 'payment',
                    field: 'error',
                }));
            }
        } else {
            const windowLocation = (typeof window !== 'undefined') ? window.location.href : '';
            mbpLogger.logError({
                appName: process.env.npm_package_name,
                module: 'mbp-checkout',
                function: 'workerCalculateCart',
                message: 'Calculate Cart - No OrderId',
                orderId: logOrderId,
                windowLocation,
            });
        }
    } catch (exp) {
        yield put(callHandleCartFailure(exp));

        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'mbp-checkout',
            function: 'workerCalculateCart',
            jsError: exp,
            message: 'Error occured while calculating order',
            orderId: logOrderId,
        });

        yield put(clearOrderItemErrors(
            cartId,
            'payment',
            { errType: 'clearAllFields', field: '' },
        ));

        // Get Cart
        yield call(retrieveCart, 'payment');
        yield put(updateCalculateShippingApplied(false));

        yield fork(processFeatureErrors, {
            data: {
                orderItemId: cartId,
                errorFeatureType: 'payment',
                errorValues: exp.response?.data,
            },
        });

        yield put(showLoadingMessageActions.flagOffShowLoadingMessage());
    }
    yield put(calculateCartComplete());
}

function* watchCalculateCart() {
    yield takeEvery(calculateCart().type, workerCalculateCart);
}

/**
 * Removes payment linked promo code.
 * eg: PAY10 - only for paypal, selecting a non-supported payment method, the promo would get removed
 */
function* workerCalculateShippingOnPaymentMethodChanged() {
    const promotion = yield select(getAppliedPromotions);
    const giftCard = yield select(getGiftCards);
    const isGiftCardCoverFullOrderTotal = yield select(disablePaymentFields);

    if (promotion?.length > 0) {
        // calculate shipping - removes non suppoted promo code
        yield put(cartServiceCalculateCart());

        yield take(cartServiceCalculateCartCompleted().type);

        if (giftCard?.length > 0 && isGiftCardCoverFullOrderTotal) {
            yield put(recalculateGiftCardTotal());

            yield take(recalculateGiftCardTotalCompleted().type);
        }

        yield call(retrieveCart);
    }
    yield put(calcualteShippingPaymentMethodIsChangedCompleted());
}

function* watchPaymentMethodChangeToCalculateShipping() {
    yield takeEvery(calcualteShippingPaymentMethodIsChanged().type, workerCalculateShippingOnPaymentMethodChanged);
}

const watchers = [
    fork(watchCalculateCart),
    fork(watchPaymentMethodChangeToCalculateShipping),
];

export {
    watchers,
};

export default {};
